import { library, dom } from '@fortawesome/fontawesome-svg-core';
// import the Facebook and Twitter icons
import { faFacebookF, faLinkedinIn, faTwitter, faApple, faSpotify, faItunes, faYoutube } from "@fortawesome/free-brands-svg-icons";
import { faBell } from "@fortawesome/free-regular-svg-icons";
import { faPlus, faCheck, faTimes, faArrowLeft, faArrowRight, faPodcast, faStar, faStarHalfAlt, faChevronDown, faChevronCircleDown, } from "@fortawesome/free-solid-svg-icons";
// add the imported icons to the library
library.add(faFacebookF, faLinkedinIn, faTwitter, faApple, faSpotify, faPodcast, faItunes, faYoutube, faBell, faPlus, faCheck, faTimes, faArrowLeft, faArrowRight, faStar, faStarHalfAlt, faChevronDown, faChevronCircleDown,);
// tell FontAwesome to watch the DOM and add the SVGs when it detects icon markup
dom.watch();
